module.exports = __webpack_public_path__ + "img/PS33.d2608321.png";